/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type IgnoredTombstoneOrHideContainer_comment = {
    readonly author: {
        readonly id: string;
        readonly username: string | null;
    } | null;
    readonly " $refType": "IgnoredTombstoneOrHideContainer_comment";
};
export type IgnoredTombstoneOrHideContainer_comment$data = IgnoredTombstoneOrHideContainer_comment;
export type IgnoredTombstoneOrHideContainer_comment$key = {
    readonly " $data"?: IgnoredTombstoneOrHideContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"IgnoredTombstoneOrHideContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IgnoredTombstoneOrHideContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = 'da7b6125bce4d142082a0972b87f1303';
export default node;
